"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = hoverWorkaround;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function hoverWorkaround(Comp) {
  /* eslint-disable react/display-name */
  return /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var PaperProps = _ref.PaperProps,
        style = _ref.style,
        props = (0, _objectWithoutProperties2["default"])(_ref, ["PaperProps", "style"]);
    return /*#__PURE__*/React.createElement(Comp, (0, _extends2["default"])({}, props, {
      ref: ref,
      style: _objectSpread({
        pointerEvents: 'none'
      }, style),
      PaperProps: _objectSpread(_objectSpread({}, PaperProps), {}, {
        style: _objectSpread({
          pointerEvents: 'auto'
        }, PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.style)
      })
    }));
  });
}